var _style, _line, _line2, _defs, _path, _line3, _line4, _path2, _path3, _path4, _path5, _defs2, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonHoodie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#32BEE1;stroke-width:17.1;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{clip-path:url(#SVGID_2_);fill:none;stroke:#32BEE1;stroke-width:17.1;}\n\t.st2{fill:none;stroke:#43CCAD;stroke-width:17.1;}\n\t.st3{fill:none;stroke:#929292;stroke-width:17.1;}\n\t.st4{clip-path:url(#SVGID_4_);fill:none;stroke:#88898A;stroke-width:17.1;stroke-miterlimit:10;}\n\t.st5{clip-path:url(#SVGID_4_);fill:#FFFFFF;}\n\t.st6{clip-path:url(#SVGID_4_);fill:none;stroke:#929292;stroke-width:17.1;}\n\t.st7{fill:none;stroke:#32BEE1;stroke-width:17.1;stroke-linejoin:round;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 578.3,
    y1: 494,
    x2: 639.4,
    y2: 494
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 420.6,
    y1: 494,
    x2: 358.6,
    y2: 494
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 264.6,
    y: 213.1,
    width: 468.8,
    height: 573.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M724.9,778.3v-154c0,0-0.2-60.3-55.3-71.1l-105.2,91.7L499,710.2l-65.3-65.3L329,553.6 c-21.5,4.9-55.8,20.6-55.8,70.7v154H724.9z"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 423.1,
    y1: 637.1,
    x2: 423.1,
    y2: 746.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 574.9,
    y1: 637.1,
    x2: 574.9,
    y2: 746.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M532.1,363.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M666.5,554.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M330.3,554.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M667.8,552.7"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 264.6,
    y: 213.1,
    width: 468.8,
    height: 573.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M613.7,284.7c0-34.7-30-63-66.8-63H433.9c-4.7,0.9-10.4,2.9-12.5,6.8c-2.6,4.8,0.4,11.4,0.4,11.4 c1.1,2.2,1.1,4.7,0,6.9c-1.1,2.2-3.2,3.7-5.7,4.3c-21.6,4.9-26,24.4-26.6,27.6l0.2,113.7c0,52.3,7.3,52.4,42.8,87.9 c31,31,88.4,51.5,138.1,1.8c37.4-37.4,43.3-37.4,43.3-87.5L613.7,284.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M392.3,325.7c0,0,42.1-34.9,53.7-44.9c11.6-9.9,34.7,14.1,83.5,14.1h83"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M613.4,536.2c-17.9-11.2-33.7-27.8-46.5-48.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M613.4,536.2c-17.9-11.2-33.7-27.8-46.5-48.4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M434.7,481.7c-13.3,23.2-30.3,41.9-49.7,54.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M434.7,481.7c-13.3,23.2-30.3,41.9-49.7,54.2"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "327.1,552 357.3,496 495.2,698.6 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "670.9,552 640.7,496 502.8,698.6 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonHoodie);
export default __webpack_public_path__ + "static/media/person_hoodie.59adf35200d88b1eb323158505a3d68f.svg";
export { ForwardRef as ReactComponent };